import { render } from "./ErrorView.vue?vue&type=template&id=5e8794da&scoped=true"
const script = {}

import "./ErrorView.vue?vue&type=style&index=0&id=5e8794da&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e8794da"]])

export default __exports__